import React, { useState, useEffect } from "react";
import {
  Card,
  Form,
  Upload,
  Input,
  Button,
  Table,
  Drawer,
  message,
  Popconfirm,
  Modal,
} from "antd";
import { PlusOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import UploadService from "../../Services/Manage/UploadService";
import { ENDPOINT } from '../../Services/ENDPOINT';


function DocumentationUpload({ user_id, departmentId, addedBy }) {
  const [uploadedDocs, setUploadedDocs] = useState([]);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [docForm] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");

  const [saving, setSaving] = useState(false);


  useEffect(() => {
    if (user_id) {
      loadDocuments();
    }
  }, [user_id]);

  const loadDocuments = async () => {
    try {
      const res = await UploadService.getDocumentsByEmpId(user_id);
      if (res.status) {
        setUploadedDocs(res.data);
      } else {
        // message.error("No documents");
      }
    } catch (err) {
      console.error(err);
      message.error("Error loading documents");
    }
  };



  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewTitle(
      file.name || (file.url && file.url.substring(file.url.lastIndexOf("/") + 1))
    );
    setPreviewVisible(true);
  };

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handleUploadChange = ({ fileList }) => {
    setFileList(fileList);
  };

  const handleRemove = async (index) => {
    try {
      const doc = uploadedDocs[index];
      if (doc.id) {
        const resp = await UploadService.deleteDocument(doc.id);
        if (resp.status) {
          message.success("Document deleted");
        } else {
          message.error("Failed to delete");
        }

        loadDocuments();
      } else {
        setUploadedDocs((prev) => prev.filter((_, i) => i !== index));
      }
    } catch (err) {
      console.error(err);
      message.error("Error deleting document");
    }
  };


  const handleEdit = (index) => {
    const doc = uploadedDocs[index];
    docForm.setFieldsValue({ title: doc.title });

 const files = doc.location
  ? doc.location.split(',').map((url, i) => {

    const baseUrl = ENDPOINT.base.replace(/\/+$/, '');
    const path = url.replace(/^\/+/, '');
    const fullUrl = url.startsWith('http') ? url : `${baseUrl}/${path}`;
    const normalizedFullUrl = fullUrl.replace(/([^:]\/)\/+/g, "$1");

    const isImage = normalizedFullUrl.match(/\.(jpg|jpeg|png|gif|bmp)$/i);

    return {
      uid: `${index}-${i}`,
      name: path.split('/').pop(),
      status: 'done',
      url: url,              
      thumbUrl: isImage ? normalizedFullUrl : null,
      originFileObj: null,
    };
  })
  : [];


    setFileList(files);
    setEditingIndex(index);
    setDrawerVisible(true);
  };


  const uploadFilesToBackend = async (files) => {
    const uploaded = [];

    for (const file of files) {
      if (file.originFileObj) {
        try {
          const resp = await UploadService.uploadFile(file.originFileObj);
          if (resp.status && resp.data) {
            let rawUrl = resp.data.location || '';


            rawUrl = rawUrl.replace(/^\/+/, '').replace(/\/{2,}/g, '/');

            uploaded.push({
              name: resp.data.originalname || file.name,
              url: rawUrl,
            });

          }
        } catch (err) {
          message.error(`Failed upload: ${file.name}`);
        }
      } else {
        uploaded.push({
          name: file.name,
          url: file.url,
        });
      }
    }

    return uploaded;
  };




const onFinish = async (values) => {
  if (saving) return;
  setSaving(true);

  if (fileList.length === 0) {
    message.error("Please upload at least one file.");
    setSaving(false);
    return;
  }

  try {
    const uploadedFiles = await uploadFilesToBackend(fileList);

    if (uploadedFiles.length === 0) {
      message.error("No files uploaded successfully.");
      setSaving(false);
      return;
    }

    const payload = {
      title: values.title,
      location: uploadedFiles.map(f => f.url).join(','),
      emp_id: user_id,
      added_by: addedBy,
    };

    let resp;
    if (editingIndex !== null) {
  
      const docId = uploadedDocs[editingIndex]?.id;
      if (!docId) {
        message.error("Document ID missing for update");
        setSaving(false);
        return;
      }

      resp = await UploadService.updateDocument(docId, payload);
    } else {

      resp = await UploadService.createDocument(payload);
    }

    if (resp.status) {
      message.success(editingIndex !== null ? "Document updated successfully" : "Document created successfully");
      setDrawerVisible(false);
      docForm.resetFields();
      setFileList([]);
      setEditingIndex(null);
      loadDocuments();
    } else {
      message.error(editingIndex !== null ? "Failed to update document" : "Failed to create document");
    }
  } catch (err) {
    message.error("Error saving document");
  } finally {
    setSaving(false);
  }
};





  const columns = [
    {
      title: "S.No",
      key: "serial",
      render: (_, __, index) => index + 1,
      width: 60,
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Files",
      dataIndex: "location",
      key: "location",
      render: (location) => {
   const files = location
  ? location.split(',').map((url) => {

    const baseUrl = ENDPOINT.base.replace(/\/+$/, '');
    const path = url.replace(/^\/+/, '');
    const fullUrl = url.startsWith('http') ? url : `${baseUrl}/${path}`;
    const normalizedFullUrl = fullUrl.replace(/([^:]\/)\/+/g, "$1");

    return {
      name: path.split('/').pop(),
      url: url,               // keep relative url here
      fullUrl: normalizedFullUrl,  // full url for display
    };
  })
  : [];



        return (
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            {files.map((file, idx) => {
              const isImage = file.name.match(/\.(jpg|jpeg|png|gif|bmp)$/i);
              return isImage ? (
                <img
                  key={idx}
              src={file.fullUrl}   
                  alt={file.name}
                  style={{
                    width: 60,
                    height: 60,
                    objectFit: "cover",
                    borderRadius: 6,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                  setPreviewImage(file.fullUrl);
                    setPreviewTitle(file.name);
                    setPreviewVisible(true);
                  }}
                />
              ) : (
                <div
                  key={idx}
                  style={{
                    width: 60,
                    height: 60,
                    lineHeight: "60px",
                    textAlign: "center",
                    backgroundColor: "#f0f0f0",
                    borderRadius: 6,
                    fontWeight: 600,
                    color: "#999",
                    fontSize: 12,
                    cursor: "pointer",
                  }}
                    onClick={() => window.open(file.fullUrl, "_blank")} 
                >
                  FILE
                </div>
              );
            })}
          </div>
        );
      },
    },

    {
      title: "Actions",
      key: "actions",
      render: (_, __, index) => (
        <div style={{ display: "flex", gap: 8 }}>
          <Button icon={<EditOutlined />} size="large" onClick={() => handleEdit(index)} />
          <Popconfirm
            title="Are you sure want to delete this document group?"
            onConfirm={() => handleRemove(index)}
            okText="Yes"
            cancelText="No"
          >
            <Button icon={<DeleteOutlined />} danger size="large" />
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <Card
      title="Documentation Upload"
      extra={
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => {
            setDrawerVisible(true);
            setEditingIndex(null);
            docForm.resetFields();
            setFileList([]);
          }}
        >
          Add Document
        </Button>
      }
    >
      <Table
        dataSource={uploadedDocs}
        columns={columns}
        rowKey={(rec) => rec.id || rec.title}
        pagination={false}
        locale={{ emptyText: "No documents uploaded yet." }}
      />

      <Drawer
        title={editingIndex !== null ? "Edit Document" : "Add Document"}
        width={400}
        onClose={() => {
          setDrawerVisible(false);
          docForm.resetFields();
          setFileList([]);
          setEditingIndex(null);
        }}
        visible={drawerVisible}
        destroyOnClose
        bodyStyle={{ paddingBottom: 80 }}
      >
        <Form layout="vertical" form={docForm} onFinish={onFinish}>
          <Form.Item
            label="File Title"
            name="title"
            rules={[{ required: true, message: "Please enter a title" }]}
          >
            <Input placeholder="Enter file title" />
          </Form.Item>

          <Form.Item
            label="Upload File(s)"
            name="file"
            rules={[
              {
                validator: () => {
                  if (fileList.length === 0 && editingIndex === null) {
                    return Promise.reject("Please upload file(s)");
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Upload
              listType="picture-card"
              beforeUpload={() => false}
              fileList={fileList}
              onChange={handleUploadChange}
              onPreview={handlePreview}
              accept="image/*,.pdf,.doc,.docx"
              multiple
            >
              {fileList.length >= 10 ? null : (
                <div>
                  <PlusOutlined />
                  <div style={{ marginTop: 8 }}>Upload</div>
                </div>
              )}
            </Upload>
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={saving}>
              {editingIndex !== null ? "Update" : "Submit"}
            </Button>

            <Button
              style={{ marginLeft: 8 }}
              onClick={() => {
                setDrawerVisible(false);
                docForm.resetFields();
                setFileList([]);
                setEditingIndex(null);
              }}
            >
              Cancel
            </Button>
          </Form.Item>
        </Form>
      </Drawer>

      <Modal
        visible={previewVisible}
        title={previewTitle}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
      >
        <img alt={previewTitle} style={{ width: "100%" }} src={previewImage} />
      </Modal>
    </Card>
  );
}

export default DocumentationUpload;
